/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitRecoveryOtpRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {InitRecoveryOtpResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const initRecoveryOtp = (request: InitRecoveryOtpRequest, options?: CashRequestOptions) => post<InitRecoveryOtpRequest, InitRecoveryOtpResponse>("/2.0/cash/init-recovery-otp", request, {...options, rejectOnError: true })